import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Modal from "./Modal";
import PrimaryButton from "../components/Buttons/PrimaryButton";
import SecondaryButton from "../components/Buttons/SecondaryButton";

interface UsageLimitModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  dailyLimit?: number;
  limitType?: "daily" | "monthly";
}

const UsageLimitModal: React.FC<UsageLimitModalProps> = ({
  isOpen,
  setIsOpen,
  dailyLimit = 10,
  limitType = "daily",
}) => {
  const resetTime = useMemo(() => {
    const now = new Date();
    const nextMidnightUTC = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)
    );
    return nextMidnightUTC.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }, []);

  const isMonthly = limitType === "monthly";

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="text-left">
        <h3 className="text-base font-semibold tracking-tight text-gray-900 mb-1">
          {isMonthly ? "Monthly limit reached" : "Daily limit reached"}
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          {isMonthly
            ? "You've used all 3,000 pages for this month. Your limit resets at the start of your next billing period."
            : <>You've reached your daily limit of {dailyLimit} pages. Your limit will reset at{" "}<span className="font-medium">{resetTime}</span>.</>
          }
        </p>
        <div className="flex gap-3 justify-end">
          <SecondaryButton type="button" onClick={() => setIsOpen(false)}>
            Close
          </SecondaryButton>
          <Link to="/pricing">
            <PrimaryButton type="button" onClick={() => setIsOpen(false)}>
              View plans
            </PrimaryButton>
          </Link>
        </div>
      </div>
    </Modal>
  );
};

export default UsageLimitModal;
